<script setup>
import { onMounted, computed, ref, watch } from 'vue'
import { Button } from '@components'

import { useAppointments } from '@store/appointments.js'
const $appointments = useAppointments()

import { useSettings } from '@store/settings.js'
const $settings = useSettings()

import { useCustomizer } from '@store/customizer.js'
const $customizer = useCustomizer()

import StaffLoader from './StaffLoader.vue'
import StaffItem from './StaffItem.vue'
import Main from '../layout/Main.vue'

onMounted(() => {
    // $appointments.matchAppointmentPreRequirement()
    $appointments.fetchStaffs()
})


const filterStaffs = computed(() => {
    let sortBy = 'staff_id'
    let sortDirection = 'ASC'
    let staffs = []

    staffs = $appointments.staffs.sort((a, b) => {
        if (Number(a[sortBy]) < Number(b[sortBy])) {
            return sortDirection == 'ASC' ? -1 : 1
        } else if (Number(a[sortBy]) > Number(b[sortBy])) {
            return sortDirection == 'ASC' ? 1 : -1
        }

        return 0
    })


    // staffs = staffs.filter(service => service.meta.status == 'publish')
    return staffs
})

const wrapperClass = computed(() => {
    if ($settings.isWidget) return 'grid grid-cols-2 gap-3'

    switch ($settings.customizer.staff.layout_type) {
        case 'grid01':
            return 'staff-list-grid01'
        case 'grid04':
            return 'staff-list-grid04'
        default:
            return 'staff-list-grid04'
    }
})

const submitStaff = (staff_id, btnClick = false) => {
    if (!staff_id) return
    $appointments.setAppointment('staff_id', staff_id)

    // bail if widget but no button click
    if ($settings.isWidget && !btnClick) return

    $appointments.nextStep()
}

const randomStaff = ref({
    staff_id: 'random',
    name: "Any Staff",
    first_name: "Any",
    last_name: "Staff",
    profile_image_url: "",
    cover_images: [],
    thumbnail_image_url: "",
    bio: "",
    highlights: "",
    title: "",
    color: "#875BF7"
})

// set staff when there is only one
watch(() => filterStaffs, () => {
    if (filterStaffs.value.length == 1) {
        submitStaff(filterStaffs.value[0].staff_id)
    }
}, { deep: true })
</script>

<style lang="scss" scoped></style>

<template>
    <Main>
        <template #content>
            <div class="staff-page-title" :style="$customizer.titleStyle">{{ $settings.customizer.staff.title || '' }}</div>

            <!-- empty staff loader -->
            <StaffLoader v-if="!$appointments.isStaffLoaded" />

            <!-- staff list -->
            <div :class="wrapperClass" v-if="$appointments.isStaffLoaded">
                <!-- <StaffItem :staff="randomStaff" /> -->
                <StaffItem v-for="(staff, index) in filterStaffs" :key="index" :staff="staff" @select="(staff) => submitStaff(staff.staff_id)" />
            </div>

        </template>

        <template #footer v-if="$settings.isWidget">
            <Button @click="submitStaff($appointments.selectedStaff.staff_id, true)" type="primary" size="md" radius="square" class="w-full" :buttonStyle="$customizer.buttonStyle">Continue</Button>
        </template>
    </Main>
</template>